import React from 'react';

const Minus = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none" {...props}>
    <g stroke="#647A85" strokeLinecap="round" clipPath="url(#a)">
      <path
        fill="#E4EAED"
        strokeLinejoin="round"
        d="M12.166 23c6.076 0 11-4.925 11-11s-4.924-11-11-11c-6.075 0-11 4.925-11 11s4.925 11 11 11Z"
      />
      <path d="M6.167 11.75h11.5" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.167 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default Minus;
